import {
  Directive,
  Input,
  ElementRef,
  NgZone,
  OnInit,
  OnDestroy,
} from '@angular/core'
import {Observable, Subject} from 'rxjs'
import {InfiniteScrollDirective} from 'ngx-infinite-scroll'
import {takeUntil, finalize} from 'rxjs/operators'

export interface ListRequest {
  offset: number
  results: number
}

export interface ResultPage {
  items: any[]
  count: number
  total: number
}

@Directive({
  selector: '[scroll-list]',
  inputs: ['loadNext', 'pageSize'],
  exportAs: 'scroll-list',
  standalone: false,
})
export class ScrollListDirective implements OnInit, OnDestroy {
  @Input() loadNext: (request: ListRequest) => Observable<ResultPage>
  @Input() pageSize = 20

  private scroll: InfiniteScrollDirective

  public data: any[] = []
  public total: number

  public loading = false
  public end = false

  constructor(
    private el: ElementRef,
    private zone: NgZone,
  ) {
    // we create an infinite-scroll-directive on the same element
    this.scroll = new InfiniteScrollDirective(el, zone)
    this.scroll.scrollWindow = false
    this.scroll.infiniteScrollDistance = 1
    this.scroll.scrolled.pipe(takeUntil(this.end$)).subscribe(() => {
      this.loadData()
    })
  }

  ngOnInit() {
    // initialize the infinite scroll to get it up and running
    this.scroll.ngAfterViewInit()
  }

  private end$: Subject<void> = new Subject<void>()
  ngOnDestroy() {
    this.scroll.ngOnDestroy()
    this.end$.next()
    this.end$.complete()
  }

  private loadData = () => {
    this.loading = true
    const request: ListRequest = {
      offset: this.data.length,
      results: this.pageSize,
    }
    let sub = this.loadNext(request)
      .pipe(finalize(() => sub.unsubscribe()))
      .subscribe((result: ResultPage) => {
        this.data.push(...result.items)
        this.total = result.total
        this.loading = false
      })
  }

  public reload = () => {
    this.data = []
    this.loadData()
  }
}
